// extracted by mini-css-extract-plugin
export default {"imageContainer":"mainUserImg_imageContainer__ZUYUa","mainHeaderAvatar":"mainUserImg_mainHeaderAvatar__sMByo","mainHeaderOrg":"mainUserImg_mainHeaderOrg__uFYWu"};